import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  icon: {
    color: "x18yk8ih",
    $$css: true
  },
  chips: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  chip: {
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x1gvq2gg",
    color: "xtt1gjl",
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xr323w7",
    $$css: true
  }
};